<template>
  <div class="select-card">
    <div class="image-area">
      <img
        class="card"
        @click.stop="handleCardSelect"
        :src="acquiredCardItem.image"
        :alt="acquiredCardItem.name"
      >
      <div class="chkblock">
        <CheckBox
          class="check-box"
          :class="{active: isChecked}"
          :isChecked="isChecked"
          @handleCheckBoxClick="handleCardSelect"
        />
      </div>
    </div>
    <div class="card-info" @click.stop="handleCardSelect">
      <div class="name">
        <span class="text">{{acquiredCardItem.name}}</span>
      </div>
      <div class="model-number">
        <span class="text">{{acquiredCardItem.model_number}}</span>
      </div>
      <span v-if="acquiredCardItem.num > 1" class="num">
        <span class="text">{{acquiredCardItem.num}}{{t('枚セット')}}</span>
      </span>
      <span class="rarity">
        <span class="text">{{acquiredCardItem.rarity_label}}</span>
      </span>
    </div>
    <div class="point_area">
      <span class="point">{{acquiredCardItem.buy_point | comma}}</span>
    </div>
  </div>
</template>

<script>
import {
  separateCharacterNumber,
} from '@/common/util/format';

import CheckBox from '@/components/atoms/CheckBox.vue';
import t from '@/plugins/i18n';

export default {
  name: 'SelectCard',
  mixins: [t],

  components: {
    CheckBox,
  },

  props: {
    acquiredCardItem: {
      type: Object,
    },
    isChecked: {
      type: Boolean,
      default: false,
    },
  },

  filters: {
    comma(value) {
      return separateCharacterNumber(value);
    },
  },

  computed: {
    returnPoint() {
      return this.isChecked ? separateCharacterNumber(this.acquiredCardItem.cardPoint) : 0;
    },
  },

  methods: {
    handleCardSelect() {
      this.$emit('handleCardSelect');
    },
  },
};
</script>

<style lang="scss" scoped>
.select-card{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 130px;
  .image-area {
    position: relative;
    .chkblock {
      position: absolute;
      left: calc(50% - 15px);
      bottom: 10px;
      .check-box{
        width: 30px;
        height: 30px;
        margin: 0 auto 0;
        border-radius: 100px;
        background-color: $lightRed;
        border-color: $lightRed;
        color: $lightGray;
        &.active {
          background-color: $mainColor;
          border-color: $mainColor;
          color: $white;
        }
      }
    }
  }
  .card{
    width: 100%;
    min-width: 113px;
  }
  .card-info{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    width: 100%;
    .name{
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      padding: 2px 0;
      .text{
        display: inline-block;
        font-family: $notoSans;
        font-size: 12px;
        color: $black;
        line-height: 1.25;
        white-space: pre-wrap;
        margin-left: 5px;
      }
    }
    .name {
      color: $black;
    }
    .model-number {
      font-size: 9px;
      color: $black;
      text-align: center;
    }
    .rarity {
      span {
        font-size: 11px;
        color: $white;
        background-color: $mainColor;
        display: block;
        padding: 3px 8px;
        border-radius: 5px;
        white-space: initial;
      }
    }
  }
  .point_area {
    font-size: 12px;
    color: $black;
    display: flex;
    align-items: center;
    .point {
      font-size: 20px;
      font-weight: 700;
      margin-left: 5px;
      position: relative;
      &:before {
        content: "P";
        font-size: 16px;
        width: 24px;
        height: 24px;
        border-radius: 100px;
        display:inline-flex;
        justify-content: center;
        align-items: center;
        background-color: $white;
        border: solid 1px $mainColor;
        color: $mainColor;
        margin-right: 5px;
        position: relative;
        top: 0px;
      }
    }
  }
}
@media screen and  (max-width: $tabletWidth) {
  .select-card {
    .card{
      width: 113px;
    }
    .point_area {
      margin-left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
